import nanoid from "nanoid";
import { PreAuthApiHandler, PostAuthApiHandler } from "@rakbank/rak-authenticator";
import {
  AUTH_CLIENT_ID,
  AUTH_RESOURCE_TYPE,
  AGENT_AUTH_RESOURCE_TYPE,
  REACT_APP_AUTH_API_KEY
} from "../constants";
const isAgentUrl = window.location.href.includes("agent/");
const resourceType = isAgentUrl ? AGENT_AUTH_RESOURCE_TYPE : AUTH_RESOURCE_TYPE;
export const DEVICE_ID = nanoid();
export const PreAuthInstance = new PreAuthApiHandler({
  client_id: AUTH_CLIENT_ID,
  resource_type: resourceType,
  client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
  device_id: DEVICE_ID,
  apiKey: REACT_APP_AUTH_API_KEY,
  baseUrl: process.env.REACT_APP_API_PATH
}).createInstance();

export const PostAuthInstance = new PostAuthApiHandler({
  client_id: AUTH_CLIENT_ID,
  resource_type: resourceType,
  client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
  device_id: DEVICE_ID,
  apiKey: REACT_APP_AUTH_API_KEY,
  baseUrl: process.env.REACT_APP_API_PATH
}).createInstance();
